import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const VolleyballIcon = observer('VolleyballIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M7.34532 5.52701C5.92137 7.65399 5.27262 10.1866 5.48815 12.7249C4.27145 12.578 3.08664 12.2093 1.99966 11.6373C2.08504 9.09053 3.115 6.70859 4.92302 4.89781C6.60966 3.20862 8.79267 2.19763 11.1425 2C9.6334 2.8543 8.33007 4.05603 7.34532 5.52701Z'
                fill='fill'
            />
            <path
                d='M8.31889 6.1808C9.63316 4.21764 11.5798 2.78947 13.8268 2.13057C14.615 2.27576 15.3781 2.51436 16.1028 2.84136C14.8319 3.75413 13.7578 4.92788 12.9614 6.28189C12.0131 7.89429 11.4843 9.7266 11.4226 11.6029C9.96451 12.3858 8.31924 12.7972 6.67182 12.7972C6.43402 10.4671 7.01189 8.13309 8.31889 6.1808Z'
                fill='fill'
            />
            <path
                d='M9.53944 19.2441C11.8169 19.2441 14.0341 18.5506 15.909 17.2513C16.3883 18.382 16.6594 19.5958 16.7052 20.826C15.2733 21.593 13.6661 22 11.9964 22C9.32449 22 6.81252 20.9579 4.92319 19.0657C4.47665 18.6185 4.07817 18.136 3.72896 17.6252C5.24829 18.5455 6.97819 19.0972 8.78492 19.2187C9.03698 19.2357 9.28851 19.2441 9.53944 19.2441Z'
                fill='fill'
            />
            <path
                d='M18.8519 11.6422C17.8174 9.53267 16.0884 7.86457 13.955 6.90575C13.1141 8.34612 12.6462 9.98127 12.5936 11.6557C14.1852 12.6472 15.5051 14.022 16.4252 15.6508C17.202 17.0258 17.6806 18.5532 17.8319 20.1205C18.2677 19.8056 18.6817 19.454 19.0691 19.066C19.2486 18.8862 19.4203 18.7008 19.5843 18.5101C20.1591 16.2124 19.9023 13.784 18.8519 11.6422Z'
                fill='fill'
            />
            <path
                d='M11.9627 12.645C10.338 13.5144 8.52429 13.9712 6.68889 13.9712C4.82758 13.9712 3.46673 13.6112 2.04036 12.9636C2.11499 13.7371 2.27813 14.4916 2.52387 15.2156C4.22759 16.883 6.46995 17.8865 8.86314 18.0474C11.1935 18.2041 13.4905 17.5456 15.3814 16.1873C14.5567 14.7436 13.3798 13.5251 11.9627 12.645Z'
                fill='fill'
            />
            <path
                d='M19.9048 11.1245C18.7784 8.82749 16.9146 6.99949 14.6142 5.917C15.3449 4.94894 16.247 4.11683 17.2733 3.46708C17.9172 3.86899 18.52 4.3471 19.0699 4.89775C20.9592 6.79001 21.9997 9.30583 21.9997 11.9818C21.9997 13.4793 21.6736 14.9266 21.0555 16.2426C21.0811 14.486 20.6935 12.7327 19.9048 11.1245Z'
                fill='fill'
            />
        </SvgElement>
    );
});
